import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'settlement.payout.crypto';
export const LABELS = makeLabels(
  {
    CRYPTOCURRENCY_SELECT_LABEL: ['select.label', 'Cryptocurrency'],
    CRYPTOCURRENCY_SELECT_PLACEHOLDER: ['select.placeholder', 'Select a cryptocurrency'],
    LOADING_ASSETS_ERORR: ['loadingAssetsError', 'Unable to get available assets. Please try again later.'],
    CRYPTO_PAYOUT_FEES: ['cryptoPayoutFees', 'Payout Fee -'],
    WALLET: {
      ADDRESS_LABEL: ['wallet.address', 'Wallet Address'],
      ADDRESS_PLACEHOLDER: ['wallet.address.placeholder', 'Enter Wallet Address'],
      TAG_LABEL: ['wallet.tag', 'Tag/Memo'],
      TAG_PLACHOLDER: ['wallet.tag.placeholder', '000000000'],
      INVALID_ADDRESS: ['wallet.invalidAddress', 'Invalid wallet address'],
      INVALID_TAG: ['wallet.invalidTag', 'Invalid tag/memo'],
      ADDRESS_REQUIRED_ERROR: ['wallet.addressRequiredError', 'Wallet address is required'],
    },
    ACTIONS: {
      CONTINUE: ['actions.continue', 'Continue'],
      CANCEL: ['actions.cancel', 'Cancel'],
      BACK: ['actions.back', 'Back'],
      ADD: ['actions.add', 'Add'],
    },
  },
  NAMESPACE,
);

export const KEYS = {
  FORM_FIELDS: {
    WALLET_ADDRESS: 'walletAddress',
    WALLET_TAG: 'walletTag',
  },
};

export default LABELS;
